// Fixed-timestep driver adapted from the spy project: the sim always steps at
// TICK_RATE regardless of display refresh; rendering interpolates between the
// last two ticks via alpha.

import { TICK_RATE } from './sim/sim';

export interface LoopHooks {
  simTick(): void;
  render(alpha: number): void;
}

const DT_MS = 1000 / TICK_RATE;
const MAX_FRAME_MS = 250; // clamp after tab-switch pauses

export function startLoop(hooks: LoopHooks): void {
  let last = performance.now();
  let acc = 0;

  function advance(now: number): void {
    acc += Math.min(now - last, MAX_FRAME_MS);
    last = now;
    // a crash in one tick must never kill the loop for good — log and go on
    try {
      while (acc >= DT_MS) {
        hooks.simTick();
        acc -= DT_MS;
      }
    } catch (err) {
      console.error('simTick crashed:', err);
      acc = 0;
    }
  }

  function frame(now: number): void {
    advance(now);
    try {
      hooks.render(acc / DT_MS);
    } catch (err) {
      console.error('render crashed:', err);
    }
    requestAnimationFrame(frame);
  }

  requestAnimationFrame(frame);

  // rAF never fires in a hidden tab; a worker metronome keeps the sim stepping
  // (no rendering) so the battle continues while the player is alt-tabbed.
  const src = `setInterval(() => postMessage(0), ${DT_MS});`;
  const worker = new Worker(URL.createObjectURL(new Blob([src], { type: 'text/javascript' })));
  worker.onmessage = () => {
    if (document.hidden) advance(performance.now());
  };
}
